import axios from 'axios';

import { XTRAM_BOT_API_URL } from '../../env';

export async function fetchSendVoiceMessage(audioBlob, session_id) {
  const formData = new FormData();

  const file = new File([audioBlob], 'voice_message.webm', {
    type: audioBlob.type || 'audio/webm',
  });

  formData.append('file', file);
  formData.append('session_id', session_id);

  const response = await axios.post(`${XTRAM_BOT_API_URL}/voice-ask`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  });

  return response.data;
}

